/**
 * Copyright 2021 Olympe S.A.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// Import Olympe runtime or DRAW
import 'olympe';

// Import project bricks 
import './common/WorkflowFilterListByState.js'; import './common/WorkflowGetHistoryAtDate.js'; import './common/WorkflowGetHistoryAtState.js'; import './common/WorkflowGetObjectHistory.js'; import './common/WorkflowGetObjectState.js'; import './common/WorkflowHasStateBeenReached.js'; import './common/WorkflowInitialize.js'; import './common/WorkflowIsObjectInState.js'; import './common/WorkflowTriggerTransition.js';

// Lib exports
export {
    initialize,
    triggerTransition,
    queryHistoryAtState,
    queryObjectState,
    queryObjectHistory,
    queryHistoryAtDate,
    queryFilterByState,
    hasStateBeenReached,
    isObjectInState,
} from './common/_workflow';

